import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./signInHistory.html"
})

export class SignInHistory implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];
  private page={pageNumber:1,pageSize:20,memberId:'',year:'',month:''}
  ngOnInit(): void {
    this.getData();
  }

  private getData(){
    this.http.getData(API.signIn_history,{
      pageNumber: this.page.pageNumber-1,
      pageSize:this.page.pageSize,
    }).then(res=>{
      this.data=res.data;
    });
  }

  private editCont(memberId:number,year,month){
    this.router.navigate(['index/signInHistory',memberId,year,month]);
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/badge/signInHistory.component.ts